/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetListingResourcesRequest} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'
import {GetListingResourcesResponse} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'


export const getListingResources = (request:GetListingResourcesRequest, options?: CashRequestOptions) => post<GetListingResourcesRequest, GetListingResourcesResponse>("/2.0/cash/get-listing-resources", request, {...options, rejectOnError: true })